import { render, staticRenderFns } from "./LowestLogicalAirfare.vue?vue&type=template&id=274e3f70&"
import script from "./LowestLogicalAirfare.vue?vue&type=script&lang=js&"
export * from "./LowestLogicalAirfare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports